webpackJsonp([72116242359702],{

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lazyImage = __webpack_require__(12);
	
	var _featuredModule = __webpack_require__(392);
	
	var _featuredModule2 = _interopRequireDefault(_featuredModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var container = _featuredModule2.default.container,
	    featuredTitle = _featuredModule2.default.title;
	
	var Featured = function (_React$PureComponent) {
	  _inherits(Featured, _React$PureComponent);
	
	  function Featured() {
	    _classCallCheck(this, Featured);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Featured.prototype.render = function render() {
	    var _props = this.props,
	        image = _props.image,
	        title = _props.title,
	        link = _props.link;
	
	
	    var article = _react2.default.createElement(
	      'article',
	      { className: container },
	      _react2.default.createElement(_lazyImage.Image, { sizes: image, alt: title }),
	      _react2.default.createElement(
	        'h2',
	        { className: featuredTitle },
	        title
	      )
	    );
	
	    return link ? _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: link },
	      article
	    ) : article;
	  };
	
	  return Featured;
	}(_react2.default.PureComponent);
	
	exports.default = Featured;
	module.exports = exports['default'];

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fragment = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _page = __webpack_require__(17);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _slider = __webpack_require__(247);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _excerptList = __webpack_require__(76);
	
	var _excerptList2 = _interopRequireDefault(_excerptList);
	
	var _excerpt = __webpack_require__(75);
	
	var _excerpt2 = _interopRequireDefault(_excerpt);
	
	var _navigation = __webpack_require__(24);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _featured = __webpack_require__(232);
	
	var _featured2 = _interopRequireDefault(_featured);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomePage = function (_React$PureComponent) {
	  _inherits(HomePage, _React$PureComponent);
	
	  function HomePage() {
	    _classCallCheck(this, HomePage);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  HomePage.prototype.render = function render() {
	    //,
	    var slides = this.props.data.frontpage.acf.slider ? this.props.data.frontpage.acf.slider.map(function (slide) {
	      return {
	        image: {
	          sizes: slide.featured_media.localFile.childImageSharp.sizes,
	          bgColor: slide.featured_media.localFile.childImageSharp.bgColor
	        },
	
	        // background
	        // lines: slide.slider_show_title ? [slide.title] : [],
	        link: slide.link
	      };
	    }) : [];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.props.data.frontpage.acf.slider && _react2.default.createElement(_slider2.default, { slides: slides }),
	      this.props.data.frontpage.acf.featured_articles && _react2.default.createElement(
	        _excerptList2.default,
	        null,
	        this.props.data.frontpage.acf.featured_articles.map(function (article) {
	          return _react2.default.createElement(_excerpt2.default, { key: article.id, data: article, featured: true });
	        })
	      ),
	      this.props.data.frontpage.acf.featured_pages && this.props.data.frontpage.acf.featured_pages.map(function (page) {
	        return _react2.default.createElement(_featured2.default, {
	          image: _extends({}, page.featured_media.localFile.childImageSharp.sizes, {
	            bgColor: page.featured_media.localFile.childImageSharp.bgColor
	          }),
	          title: page.title,
	          link: page.link,
	          key: page.link
	        });
	      }),
	      _react2.default.createElement(_navigation2.default, null)
	    );
	  };
	
	  return HomePage;
	}(_react2.default.PureComponent);
	
	exports.default = HomePage;
	var fragment = exports.fragment = '** extracted graphql fragment **';

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sliderModule = __webpack_require__(69);
	
	var _sliderModule2 = _interopRequireDefault(_sliderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Slide from './slide'
	
	// import { container } from '../../styles/components/container.module.scss';
	
	
	var svg = _sliderModule2.default.svg,
	    container = _sliderModule2.default.container;
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.svg = null;
	    return _this;
	  }
	
	  Slider.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    __webpack_require__.e/* nsure */(14718892253751, function () {
	      _this2.svg = __webpack_require__(159);
	      _this2.forceUpdate();
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: _sliderModule2.default.slider },
	      this.svg ? _react2.default.createElement(this.svg, { slides: this.props.slides }) : _react2.default.createElement(
	        'svg',
	        {
	          xmlns: 'http://www.w3.org/2000/svg',
	          xmlnsXlink: 'http://www.w3.org/1999/xlink',
	          className: svg,
	          version: '1.1',
	          viewBox: '0 0 1920.1 1080.2',
	          preserveAspectRatio: 'xMidYMid slice',
	          width: '100%',
	          height: '1000'
	        },
	        _react2.default.createElement('rect', {
	          backgroundColor: this.props.slides[0].image.bgColor,
	          x: '0',
	          y: '0',
	          width: '1920.1',
	          height: '1080.2'
	        })
	      )
	    );
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;
	module.exports = exports['default'];

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-styles-components----featured-module---container---FIZsW src-styles-components----container-module---container---1YJKJ","title":"src-styles-components----featured-module---title---2NrYj"};

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-styles-components----slider-module---container---3yt86 src-styles-components----container-module---container---1YJKJ","slider":"src-styles-components----slider-module---slider---1Nl8j","svg":"src-styles-components----slider-module---svg---3ivD3","text":"src-styles-components----slider-module---text---1VJb3","overlay":"src-styles-components----slider-module---overlay---1gCP9","controlsContainer":"src-styles-components----slider-module---controlsContainer---m_Lnz src-styles-components----container-module---container---1YJKJ","pinBottom":"src-styles-components----slider-module---pinBottom---33N6J","pager":"src-styles-components----slider-module---pager---1Afhq","pagerButton":"src-styles-components----slider-module---pagerButton---xBVR8","pagerSvg":"src-styles-components----slider-module---pagerSvg---Cn9xE","mouseIndicator":"src-styles-components----slider-module---mouseIndicator---2lHjg","mouseIndicatorSvg":"src-styles-components----slider-module---mouseIndicatorSvg---3LEXB","mouseIndicatorAnimation":"src-styles-components----slider-module---mouseIndicatorAnimation---2fxMC","mouseIndicatorScroll":"src-styles-components----slider-module---mouseIndicatorScroll---3_wEp","mouseIndicatorScrollAnimation":"src-styles-components----slider-module---mouseIndicatorScrollAnimation---1kcBm"};

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(17);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _frontpage = __webpack_require__(234);
	
	var _frontpage2 = _interopRequireDefault(_frontpage);
	
	var _seo = __webpack_require__(32);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_Page) {
	  _inherits(Component, _Page);
	
	  function Component() {
	    _classCallCheck(this, Component);
	
	    return _possibleConstructorReturn(this, _Page.apply(this, arguments));
	  }
	
	  Component.prototype.onMountGlobalState = function onMountGlobalState(state) {
	    return _extends({}, state, {
	      whiteLogo: true
	    });
	  };
	
	  Component.prototype.render = function render() {
	    return [_react2.default.createElement(_seo2.default, _extends({}, this.props.data.frontpage, this.props.pathContext, {
	      key: 'seo'
	    })), _react2.default.createElement(_frontpage2.default, { data: this.props.data })];
	  };
	
	  return Component;
	}(_page2.default);
	
	exports.default = Component;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-front-js-791393579c43917d4131.js